<div class="mat-dialog-header">
  <div class="mat-dialog-title">{{title}}</div>
  <fa-icon (click)="toastAndClose()" [icon]="['fas', 'close']"></fa-icon>
</div>
<mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>
<div mat-dialog-content>
  <div *ngIf="!scanning" class="subtitle">
    Select Behavior Code to Start Scanning:
  </div>
  <div *ngIf="scanning" class="secondary-subtitle">
    Ready to Scan:
  </div>

  <mat-form-field class="full-width-input">
    <mat-label>Behavior Type</mat-label>
    <input type="text" matInput [formControl]="behaviorCodeTypeIdControl" [matAutocomplete]="auto" placeholder="Select an option">
    <mat-icon matSuffix class="icon" *ngIf="!behaviorCodeTypeIdControl.value">arrow_drop_down</mat-icon>
    <button
      [disabled]="scanning"
      matSuffix
      class="icon"
      *ngIf="behaviorCodeTypeIdControl.value"
      mat-icon-button
      aria-label="Clear"
      (click)="onClear('behaviorCodeTypeIdControl'); onClear('behaviorCodeIdControl')"
    >
      <mat-icon>close</mat-icon>
    </button>
    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displaySelectedOption.bind(this, 'behaviorCodeTypeOptions')" showPanel="true">
      <mat-option *ngFor="let option of filteredBehaviorTypes | async" [value]="option">
        {{option.name}}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>

  <ng-container *ngIf="!isLoading && behaviorCodeOptions?.length">
    <mat-form-field class="full-width-input">
      <mat-label>Behavior Code</mat-label>
      <input type="text" matInput [formControl]="behaviorCodeIdControl" [matAutocomplete]="autoCode" placeholder="Select an option">
      <mat-icon matSuffix class="icon" *ngIf="!behaviorCodeIdControl.value">arrow_drop_down</mat-icon>
      <button
        [disabled]="scanning"
        matSuffix
        class="icon"
        *ngIf="behaviorCodeIdControl.value"
        mat-icon-button
        aria-label="Clear"
        (click)="onClear('behaviorCodeIdControl')"
      >
        <mat-icon>close</mat-icon>
      </button>
      <mat-autocomplete #autoCode="matAutocomplete" [displayWith]="displaySelectedOption.bind(this, 'behaviorCodeOptions')" showPanel="true">
        <mat-option *ngFor="let option of filteredBehaviorCodes | async" [value]="option">
          {{option.name}}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </ng-container>

  <ng-container *ngIf="!isLoading && behaviorCodeReactionOptions?.length">
    <mat-form-field class="full-width-input">
      <mat-label>Select Reaction</mat-label>
      <input type="text" matInput [formControl]="behaviorCodeReactionIdControl" [matAutocomplete]="autoReactions" placeholder="Select an option">
      <mat-icon matSuffix class="icon" *ngIf="!behaviorCodeReactionIdControl.value">arrow_drop_down</mat-icon>
      <button
        [disabled]="scanning"
        matSuffix
        class="icon"
        *ngIf="behaviorCodeReactionIdControl.value"
        mat-icon-button
        aria-label="Clear"
        (click)="onClear('behaviorCodeReactionIdControl')"
      >
        <mat-icon>close</mat-icon>
      </button>
      <mat-autocomplete #autoReactions="matAutocomplete" [displayWith]="displaySelectedOption.bind(this, 'behaviorCodeReactionOptions')" showPanel="true">
        <mat-option *ngFor="let option of filteredReactions | async" [value]="option">
          {{option.name}}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </ng-container>

  <ng-container
    *ngIf="!isLoading && behaviorCodeOptions?.length && hasPrivilege(PrivilegeEnum.CREATE_BEHAVIOR_NOTES)">
    <mat-form-field class="text-area">
      <mat-label>Notes (Optional)</mat-label>
      <textarea
        class="text-area"
        cdkAutosizeMinRows="1"
        cdkAutosizeMaxRows="15"
        [formControl]="notesControl"
        matInput
        placeholder="Notes"></textarea>
    </mat-form-field>
  </ng-container>

  <div *ngIf="scanning" class="scan-backup">
    <div class="subtitle">
      Can’t scan? Type the ext. student ID to track student.
    </div>
    <div class="scan-input">
      <mat-form-field>
        <mat-label>Ext Student ID</mat-label>
        <input
          data-test-id="STUDENT_EXT_ID_FILTER_INPUT"
          matInput
          [formControl]="studentExtId"
          (keydown.enter)="trackBehavior()" />
      </mat-form-field>
      <button 
        mat-flat-button
        class="modal-cancel-button"
        (click)="trackBehavior()"
      >
        TRACK
      </button>
    </div>
  </div>
</div>
<div mat-dialog-actions align="end" class="modal-dialog-actions">
  <div class="modal-action-row">
    <button
      *ngIf="!scanning"
      type="button"
      mat-button
      class="modal-cancel-button"
      (click)="dialogRef.close();">
      CANCEL
    </button>
    <button
      [disabled]="isLoading || isSubmitDisabled"
      mat-button
      [ngClass]="scanning ? 'modal-delete-button' : 'modal-submit-button'"
      (click)="onScan()">
       <fa-icon [icon]="['fas', 'barcode-read']" size="xl"></fa-icon>
      &nbsp; {{ scanning ? 'STOP' : 'START'}} SCANNING
    </button>
  </div>
</div>
